export default __webpack_public_path__ + "b55e2a858ce952accfebd5ef782fb971.png";